export const formFields = <{[key: string]: any}> {
    signIn: {
      username: {
        placeholder: 'Email',
        isRequired: true,
        order: 1,
      },
      password: {
        placeholder: 'Password',
        isRequired: true,
        order: 2,
      },
    },
    signUp: {
      name: {
        label: 'Name',
        placeholder: 'Name',
        isRequired: true,
        order: 1,
      },
      email: {
        label: 'Email - if you have existing subscriptions, use the same email',
        placeholder: 'Email',
        isRequired: true,
        order: 2,
      },
      password: {
        label: 'Password - at least 8 characters',
        placeholder: 'Password',
        isRequired: false,
        order: 3,
      },
      confirm_password: {
        // https://github.com/aws-amplify/amplify-ui/issues/2530
        label: 'Confirm Password',
        placeholder: 'Confirm Password',
        isRequired: false,
        order: 4,
      },
    },
    forceNewPassword: {
      password: {
        placeholder: 'Enter your Password',
      },
    },
    forgotPassword: {
      username: {
        placeholder: 'Enter your email',
      },
    },
    confirmResetPassword: {
      confirmation_code: {
        placeholder: 'Confirmation Code',
        label: 'Confirmation Code',
        isRequired: false,
      },
      confirm_password: {
        placeholder: 'Confirm Password',
      },
    },
    setupTotp: {
      QR: {
        totpIssuer: 'test issuer',
        totpUsername: 'amplify_qr_test_user',
      },
      confirmation_code: {
        label: 'Confirmation Code',
        placeholder: 'Confirmation Code',
        isRequired: false,
      },
    },
    confirmSignIn: {
      confirmation_code: {
        label: 'Confirmation Code',
        placeholder: 'Confirmation Code',
        isRequired: false,
      },
    },
}